import script from "./AddInvoice.vue?vue&type=script&setup=true&lang=js"
export * from "./AddInvoice.vue?vue&type=script&setup=true&lang=js"

import "./AddInvoice.vue?vue&type=style&index=0&id=76d874cb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76d874cb"]])

export default __exports__